var sourceUrl;
var documentWidth = $(document).width();
var datePickerMode = localStorage.getItem("datePickerMode") ? Number(localStorage.getItem("datePickerMode")) : 2;

$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  datePicker();

  // show more description in property
  $(".js-show-more").on("click", function () {
    $(".js-property-footer-content").toggleClass("auto-height");
    $(this).toggleClass("active");
  });

  $(".js-ship-booking-infant-info").click(function () {
    $(this).closest(".js-ship-travelers").find(".js-ship-booking-infant-description").slideDown();
  });

  $(".js-ship .js-ship-auto-search").each(function () {
    autoSearch($(this));
  });

  //tab click
  var flag = 0;

  radioCheckedValue = $(".js-ship .js-ship-routes-select input:radio:checked").val();

  $(".js-ship-tab").click(function () {
    routesTypeCheck(radioCheckedValue);
  });

  routesTypeCheck(radioCheckedValue);

  ////////////traveler count form

  const passemgers = (target) => {
    return {
      adult: Number($(target).closest(".js-ship-travelers").find(".js-ship-passenger-adult").find(".js-number-passenger").text()),
      child: Number($(target).closest(".js-ship-travelers").find(".js-passenger-child").find(".js-number-passenger").text()),
      infant: Number(
        $(target).closest(".js-ship-travelers").find(".js-passenger-infant").find(".js-number-passenger").text(),
      ),
    };
  };

  const updatePassenger = (target, type, value) => {
    $(target).parent().find(".js-number-passenger").text(value);
    $(target).closest(".js-ship-economy-target").find(`.js-ship-${type}-number`).text(value);
    handlePassengerLimitErrorMessage(target);
  };

  const increaseAdult = (target) => {
    let { adult, child } = passemgers(target);

    if (adult + child > 8) handlePassengerLimitErrorMessage(target, "maxPassengersNumbers");
    else updatePassenger(target, "adults", adult + 1);
  };

  const increaseChild = (target) => {
    let { adult, child } = passemgers(target);

    if (adult + child > 8) handlePassengerLimitErrorMessage(target, "maxPassengersNumbers");
    else updatePassenger(target, "child", child + 1);
  };

  const increaseInfant = (target) => {
    let { adult, infant } = passemgers(target);

    if (adult <= infant) handlePassengerLimitErrorMessage(target, "validationOfAdultAndInfantsNumber");
    else updatePassenger(target, "infant", infant + 1);
  };

  const decreaseAdult = (target) => {
    let { adult, infant } = passemgers(target);

    if (adult <= Number($(target).parent().find(".js-number-passenger").data("min")))
      handlePassengerLimitErrorMessage(target, "minPassengersNumbers");
    else if (adult <= infant) handlePassengerLimitErrorMessage(target, "validationOfAdultAndBabiesNumber");
    else updatePassenger(target, "adults", adult - 1);
  };

  const decreaseChild = (target) => {
    let { child } = passemgers(target);

    if (child > Number($(target).parent().find(".js-number-passenger").data("min")))
      updatePassenger(target, "child", child - 1);
  };

  const decreaseInfant = (target) => {
    let { infant } = passemgers(target);

    if (infant > Number($(target).parent().find(".js-number-passenger").data("min")))
      updatePassenger(target, "infant", infant - 1);
  };

  const handlePassengerLimitErrorMessage = (target, msg) => {
    const errorMessages = {
      maxPassengersNumbers: "تعداد مسافران غیر از نوزاد بیشتر از ۹ نفر نمیتواند باشد",
      validationOfAdultAndInfantsNumber: "تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد",
      minPassengersNumbers: "حداقل تعداد مسافران یک بزرگسال می باشد",
      validationOfAdultAndBabiesNumber: "تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد",
    };

    // for desktop
    let errorLocation = $(target)
      .closest(".js-booking-section.active")
      .find(".js-ship .js-ship-section-active .js-ship-travelers");

    if (errorLocation.find(".js-error-travelers").length)
      errorLocation.find(".js-error-travelers").text(errorMessages[msg] || "");
    else
      errorLocation.append(
        `<small class="text-red hide-in-not-desktop js-error-travelers">${errorMessages[msg] || ""}</small>`,
      );

    // for mobile
    $(target)
      .closest(".js-ship-travelers")
      .find(".js-ship-validation-economy")
      .text(errorMessages[msg] || "");
  };

  const findPassengerType = (target) => {
    let listElementClass = $(target).closest("li").attr("class");

    return listElementClass.includes("js-ship-passenger-adult")
      ? "adult"
      : listElementClass.includes("js-passenger-child")
        ? "child"
        : listElementClass.includes("js-passenger-infant")
          ? "infant"
          : undefined;
  };

  var sum;
  // increase passengers
  $(".js-ship .js-count-box .js-max").click(async function () {
    let actions = {
      adult: increaseAdult,
      child: increaseChild,
      infant: increaseInfant,
    };

    if (actions[findPassengerType($(this))]) await actions[findPassengerType($(this))]($(this));

    calcSum($(this).closest(".js-ship-economy-target"));
  });

  // decrease passengers
  $(".js-ship .js-count-box .js-min").click(async function () {
    let actions = {
      adult: decreaseAdult,
      child: decreaseChild,
      infant: decreaseInfant,
    };

    if (actions[findPassengerType($(this))]) await actions[findPassengerType($(this))]($(this));

    calcSum($(this).closest(".js-ship-booking-container"));
  });

  $(".js-ship .js-ship-economy-target").each(function () {
    calcSum($(this));
  });

  function calcSum(obj) {
    sum = 0;
    obj.find("li.js-ship-passenger-list .js-number-passenger").each(function () {
      sum += Number($(this).text());
      obj.find(".js-ship-traveles-number .js-number").text(sum);
    });
  }

  //select cabin type
  $(".js-ship .js-ship-cabin-type").change(function () {
    $(".js-ship-cabin-type-label").text(this.value).attr("title", $(this).val());
  });

  //route type select
  var radioCheckedValue = $('.js-ship input:radio[name*="routeType"]:checked').val();

  $(".js-ship-routes-select").on("change", "input", function () {
    routesTypeCheck($(this).val(), $(this));
  });

  function routesTypeCheck(value, obj) {
    if (value === "twoWay") {
      $(obj).closest(".js-booking-section.active").find(".js-ship").find(".returnDate").show();

      $(".js-ship-one-or-two-route-container").show().addClass("js-ship-section-active");

      $(".js-ship-serveral-routes-container").hide();

      $(".js-ship-departure").addClass("two-calendar");

      sum = $(".js-booking-section.active .js-one-or-two-route-passengers-sum").text();
    } else if (value === "oneWay") {
      sum = $(".js-booking-section.active .js-one-or-two-route-passengers-sum").text();

      // $(".js-booking-section.active .js-ship .returnDate").hide();

      $(obj).closest(".js-booking-section.active").find(".js-ship").find(".returnDate").hide();

      $(".js-ship-departure").removeClass("two-calendar");

      $(".js-ship-one-or-two-route-container").show().addClass("js-ship-section-active");

      $(".js-ship-serveral-routes-container").hide().removeClass("js-ship-section-active");
    } else if (value === "severalWay") {
      sum = $(".js-booking-section.active .js-ship-serveral-routes-passengers-sum").text();

      $(".js-ship-one-or-two-route-container").hide().removeClass("js-ship-section-active");

      $(".js-ship-departure").removeClass("two-calendar");

      $(".js-ship-serveral-routes-container").show().addClass("js-ship-section-active");
    }
  }

  function shipPassengerLimit({ adult, child, infant }, target) {
    // target: HTMLElement, adult: number, child: number, infant: number
    let msg = "";
    if (+adult < 1) msg = "تعداد مسافر بزرگسال باید حداقل یک نفر باشد";
    if (+adult + +child > 9) {
      msg = "تعداد مسافران غیر از نوزاد بیشتر از ۹ نفر نباید باشد";
    }
    if (+infant > +adult) {
      msg = `نوزادان همیشه با والدین یا سرپرستان خود سفر میکنند (هر بزرگسال یک کودک)، ${msg}`;
    }

    if (msg && $(window).width() > 767) {
      let errorLocation = $(target)
        .closest(".js-booking-section.active")
        .find(".js-ship .js-ship-section-active .js-ship-travelers");

      if (errorLocation.find(".js-error-travelers").length) errorLocation.find(".js-error-travelers").text(msg);
      else errorLocation.append(`<small class="text-red hide-in-not-desktop js-error-travelers">${msg}</small>`);

      $(target)
        .closest(".js-booking-section.active")
        .find(".js-ship .js-ship-section-active .js-ship-economy-target>button")
        .next(".js-ship-travelers")
        .fadeToggle();
    }

    return msg;
  }

  ////search btn
  $(".js-ship button.js-ship-search").click(function (e) {
    var localStorageKey = `${window.prefixSearchHistory}-${$(".js-search-holder-landing").attr("id") ||
      $(this).closest(".js-tab-nav").find(".js-tab-content>div.active").attr("id")
      }`;
    var searchHistoryItem = {
      value: {},
      baseUrl: "",
      expire: "",
    };

    $(this).closest(".js-booking-section.active").find(".js-ship").find(".error-message").remove();
    var valid = true;
    var routeValid = true;
    var message = "";

    var baseUrl = "/" + "fa" + "/flight/";

    var cabinTypeNumber;

    //external
    var routeType = $(this)
      .closest(".js-booking-section.active")
      .find(".js-ship")
      .find(".js-ship-routes-select input:checked")
      .val(); // oneWay | twoWay | severalWay
    searchHistoryItem.value.routeType = routeType;

    var cabinType = $(this)
      .closest(".js-booking-section.active")
      .find(".js-ship")
      .find(".js-ship-cabin-type-label")
      .attr("title"); // First | Business | Economy | Premium | <empty string>
    searchHistoryItem.value.cabinType = cabinType;

    switch (cabinType) {
      case "First":
        cabinTypeNumber = 1;
        break;

      case "Business":
        cabinTypeNumber = 2;
        break;

      case "Economy":
        cabinTypeNumber = 3;
        break;

      case "Premium":
        cabinTypeNumber = 4;
        break;
    }

    searchHistoryItem.value.cabinTypeNumber = cabinTypeNumber;

    if ($(".js-tab-nav").length) {
      baseUrl +=
        $(".js-tab-nav").find(".js-ship-tab.active").attr("data-searchType") == "external-ship"
          ? "int/" // international ship
          : "dom/"; //internal ship
    } else {
      baseUrl +=
        $(this).closest(".js-booking-section.active").attr("data-searchType") == "external-ship" ? "int/" : "dom/";
    }

    if (routeType !== "severalWay") {
      // oneWay or twoWay
      if ($(this).closest(".js-booking-section.active").find(".js-ship").find(".js-ship-from-city").data("code")) {
        // from-city
        let fromCity = $(this).closest(".js-booking-section.active").find(".js-ship").find(".js-ship-from-city").data();

        baseUrl += fromCity.code + "-";
        searchHistoryItem.value.fromCity = {
          code: fromCity.code,
          value: fromCity.value,
          title: fromCity.title,
        };
      } else {
        valid = false;
      }
      if ($(this).closest(".js-booking-section.active").find(".js-ship").find(".js-ship-to-city").data("code")) {
        // to-city
        let toCity = $(this).closest(".js-booking-section.active").find(".js-ship").find(".js-ship-to-city").data();

        baseUrl += toCity.code;
        searchHistoryItem.value.toCity = {
          code: toCity.code,
          value: toCity.value,
          title: toCity.title,
        };
      } else {
        valid = false;
      }
      baseUrl += "/?Cab=" + cabinTypeNumber + "&";

      var startDateValue = $(this).closest(".js-ship").find(".js-ship-pick-date");

      if (startDateValue.val() && startDateValue.next().val()) {
        // start-date
        baseUrl += "Dep=" + startDateValue.next().val();
        searchHistoryItem.value.startDateValue = startDateValue.next().val();
      } else {
        valid = false;
      }

      //dom ship and rafto bargasht
      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find('.js-ship-routes-select input:radio[name*="routeType"]:checked')
          .val() === "twoWay"
      ) {
        // end date
        var endDateValue = $(this).closest(".js-ship").find(".js-ship-pick-date2");

        if (endDateValue.val() && endDateValue.next().val()) {
          baseUrl += "&Ret=" + endDateValue.next().val();
          searchHistoryItem.value.endDateValue = endDateValue.next().val();
        } else {
          valid = false;
        }
      }

      baseUrl +=
        "&Adt=" +
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-ship-passenger-adult .js-number-passenger")
          .text();

      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-passenger-child .js-number-passenger")
          .text() > 0
      ) {
        baseUrl +=
          "&Chd=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-ship")
            .find(".js-ship-section-active .js-passenger-child .js-number-passenger")
            .text();
      }
      if (
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-passenger-infant .js-number-passenger")
          .text() > 0
      ) {
        baseUrl +=
          "&Inf=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-ship")
            .find(".js-ship-section-active .js-passenger-infant .js-number-passenger")
            .text();
      }

      searchHistoryItem.value.passenger = {
        adult: $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-ship-passenger-adult .js-number-passenger")
          .text(),
        child: $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-passenger-child .js-number-passenger")
          .text(),
        infant: $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-passenger-infant .js-number-passenger")
          .text(),
      };

      if (searchHistoryItem.value.fromCity?.code)
        routeValid =
          searchHistoryItem.value.fromCity?.code?.trim()?.toLowerCase() !==
          searchHistoryItem.value.toCity?.code?.trim()?.toLowerCase();
    } else if (routeType === "severalWay") {
      searchHistoryItem.value.trip = [];
      $(this)
        .closest(".js-booking-section.active")
        .find(".js-ship")
        .find(".js-ship-serveral-routes-container .js-ship-auto-search")
        .each(function (index, value) {
          if ($(this).val() !== "") {
            searchHistoryItem.value.trip.push({
              code: $(this).data("code"),
              value: $(this).data("value"),
            });
            var valThis = $(this).data("code");
            baseUrl += valThis;

            if ($(".js-ship-serveral-routes-container .js-ship-auto-search").length - 1 != index) {
              baseUrl += "-";
            }
          } else {
            valid = false;
          }
        });

      baseUrl += "/?Cab=" + cabinTypeNumber + "&";

      searchHistoryItem.value.date = [];
      $(this)
        .closest(".js-booking-section.active")
        .find(".js-ship")
        .find(".js-ship-section-active .js-ship-pick-date")
        .each(function (index, value) {
          if ($(this).val() !== "") {
            baseUrl += "Dep=" + $(this).next().val() + "&";
            searchHistoryItem.value.date.push($(this).next().val());
          } else {
            valid = false;
          }
        });

      baseUrl +=
        "Adt=" +
        $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-ship-passenger-adult .js-number-passenger")
          .text();

      if (
        Number(
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-ship")
            .find(".js-ship-section-active .js-passenger-child .js-number-passenger")
            .text(),
        ) > 0
      ) {
        baseUrl +=
          "&Chd=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-ship")
            .find(".js-ship-section-active .js-passenger-child .js-number-passenger")
            .text();
      }
      if (
        Number(
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-ship")
            .find(".js-ship-section-active .js-passenger-infant .js-number-passenger")
            .text(),
        ) > 0
      ) {
        baseUrl +=
          "&Inf=" +
          $(this)
            .closest(".js-booking-section.active")
            .find(".js-ship")
            .find(".js-ship-section-active .js-passenger-infant .js-number-passenger")
            .text();
      }

      searchHistoryItem.value.passenger = {
        adult: $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-ship-passenger-adult .js-number-passenger")
          .text(),
        child: $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-passenger-child .js-number-passenger")
          .text(),
        infant: $(this)
          .closest(".js-booking-section.active")
          .find(".js-ship")
          .find(".js-ship-section-active .js-passenger-infant .js-number-passenger")
          .text(),
      };

      routeValid = !searchHistoryItem.value.trip.some(
        (tripItem, i, arr) => i % 2 === 0 && tripItem?.code && tripItem?.code === arr[i + 1]?.code,
      );
    }

    message = shipPassengerLimit(searchHistoryItem.value.passenger, $(this));

    if (!valid || !routeValid || message) {
      let msg = [];
      if (!valid) msg.push("لطفا تمام فیلدها را کامل نمایید");
      if (!routeValid) msg.push("مبدا و مقصد نمی تواند یکسان باشد");
      if (message) msg.push(message);
      $(this)
        .closest(".js-booking-section.active")
        .find(".js-ship")
        .append(`<span class='error-message'>${msg.join("، ")}</span>`);
      return false;
    } else {
      searchHistoryItem = {
        ...searchHistoryItem,
        baseUrl: baseUrl,
        expire: !!startDateValue ? startDateValue.next().val() : searchHistoryItem.value.date[0],
      };
      window.updateLocalStorage(localStorageKey, searchHistoryItem);

      window.location.assign(baseUrl);
    }
  });

  //////////
  $(".js-ship-exchange-btn").click(function () {
    var input1 = $(this).closest(".js-ship-cities").find(".js-ship-from-city");
    var input2 = $(this).closest(".js-ship-cities").find(".js-ship-to-city");
    if (!input1.data("code") || !input2.data("code")) return;
    var inputList1 = input1.closest(".js-ship-city").find(".js-ship-search-list");
    var inputList2 = input2.closest(".js-ship-city").find(".js-ship-search-list");

    var valueHolderInMobile1 = $(this).closest(".js-ship-cities").find(".js-ship-from-city").siblings(".js-input-layout");
    var valueHolderInMobile2 = $(this).closest(".js-ship-cities").find(".js-ship-to-city").siblings(".js-input-layout");

    $(input2).swap(input1);

    $(valueHolderInMobile2).swap(valueHolderInMobile1);

    $(inputList2).swap(inputList1);

    input1.removeClass("js-ship-from-city").addClass("js-ship-to-city");
    input2.removeClass("js-ship-to-city").addClass("js-ship-from-city");
  });
  //swap elements
  $.fn.swap = function (elem) {
    elem = elem.jquery ? elem : $(elem);
    return this.each(function () {
      $(document.createTextNode("")).insertBefore(this).before(elem.before(this)).remove();
    });
  };
  //traveller menu close
  $(document).mouseup(function (e) {
    if (
      !$(".js-ship-economy-target").is(e.target) && // if the target of the click isn't the container...
      $(".js-ship-economy-target").has(e.target).length === 0
    ) {
      if ($(window).width() > 767) {
        // ... nor a descendant of the container
        $(".js-ship-travelers").fadeOut();
      } else {
        $(".js-ship-travelers").removeClass("show-tmenu");
      }
    }
  });

  ///events control in mobile
  $(".js-ship").delegate(".js-close-auto-complete", "click", function () {
    $("input#js-ship-from-city, input#js-ship-to-city").autocomplete("close");
    $(".js-ship-city").removeClass("show-mobile");
    $(".js-ship-search-list>ul").hide();
    $("html").removeClass("no-scroll");
  });
});

function GetLanguage() {
  return window.location.pathname.split("/")[1];
}

//add ship in several rout
$(document).delegate(".js-add-ship-route", "click", function () {
  if ($(".js-ship-routes-row").length <= 5) {
    var toCityValue = $(".js-ship-routes-row").last().find(".js-ship-to-city").val();
    var toCityValueAttr = $(".js-ship-routes-row").last().find(".js-ship-to-city").attr("data-code");
    var toCitydirection = $(".js-ship-routes-row").last().find(".js-ship-to-city").css("direction");

    var language = GetLanguage();

    var routeRowTemplate = `
    <div class="flight-booking-inner js-ship-routes-row js-added-ship">
<div class="flight-booking-inner-title">
  <label class="js-ship-route-number hide-in-desktop"></label>
  <button class="flight-booking__remove js-delete-ship-route">
  <i class="icon-close-circle"></i>
  </button>
</div>

    <div class="flight-booking__item flight-booking__item--city js-ship-cities p--0" data-searchType="external-ship">
        <div class="flight-booking__item flight-booking__item--from flight-booking__city-item js-ship-city">
            <div class="flight-booking__city-item-inner">
                <div>
                <div class="flight-booking__item-input-title hide-in-desktop">
                                                                                    <label class="hide-in-desktop">از</label>
                                                                                    <button class="js-close-auto-complete">
                                                                                        <i class="icon-close"></i>
                                                                                    </button>
                                                                                </div>
                    <div class="form-element-group form-element-group--with-icon">
                    
                        <div>
                        <div class="search-input-layout-in-mobile js-input-layout"></div>
                            <input type="text" data-hj-whitelist id="js-ship-from-city" autocomplete="off" class="js-ship-auto-search js-ship-from-city" placeholder='از' />
                            <div class="flight-booking__list js-ship-search-list"></div>
                            <i class="icon-plane-line"></i>
                        </div>
                    </div>
                    <div class="flight-booking__item-loader js-search-loading">کمی صبر کنید</div>
                </div>

                <button class="flight-booking__exchange btn btn--light js-ship-exchange-btn">
                    <i class="icon-exchange"></i>
                </button>
            </div>
        </div>

        <div class="flight-booking__item flight-booking__item--none-border flight-booking__city-item js-ship-city flight-booking__item--to">
            <div class="flight-booking__city-item-inner">
                <div>
                    <div class="flight-booking__item-input-title">
                        <label class="hide-in-desktop">به</label>
                        <button class="js-close-auto-complete">
                            <i class="icon-close"></i>
                        </button>
                    </div>
                    <div class="form-element-group">
              
                        <div>
                        <div class="search-input-layout-in-mobile js-input-layout"></div>
                            <input type="text" data-hj-whitelist id="js-ship-to-city" autocomplete="off" class="js-ship-auto-search js-ship-to-city" placeholder='به' />
                            <div class="flight-booking__list js-ship-search-list"></div>
                            <i class="icon-flight-land"></i>
                        </div>
                    </div>
                    <div class="flight-booking__item-loader js-search-loading">کمی صبر کنید ...</div>
                </div>
            </div>
        </div>
    </div>

    <div class="flight-booking__item flight-booking__item--departure rangeDates p--0">
        <div class="flight-booking__departure js-ship-departure">
            <div>                
                <div class="form-element-group form-element-group--with-icon">
                  <div>
                      <input type="text" data-hj-whitelist readonly class="js-ship-pick-date pickDate" placeholder="تاریخ" />
                      <input type="hidden" />
                      <i class="icon-calendar"></i>
                  </div>
                </div>
            </div>
        </div>
    </div>
  
</div>
    `;
    $(".js-ship-routes-row").last().after($(routeRowTemplate));
    for (var i = 0; i < $(".js-ship-route-number").length; i++) {
      var item = $(".js-ship-route-number")[i];
      $(item).text(`مسیر ${i + 1}`);
    }

    srcType = $(this).attr("data-searchType");

    getUrl(srcType);

    setTimeout(function () {
      $(".js-flight .js-ship-auto-search").each(function () {
        autoSearch($(this));
      });
    }, 100);

    newdatePicker();
  }
});

//delete ship
$(document).delegate(".js-delete-ship-route", "click", function () {
  $(this).closest(".js-added-flight").remove();
  for (var i = 0; i < $(".js-ship-route-number").length; i++) {
    var item = $(".js-ship-route-number")[i];
    $(item).text(`مسیر ${i + 1}`);
  }
});

//delete all ship
$(document).delegate(".js-clear-all-ship", "click", function () {
  $(".js-added-ship").remove();
  for (var i = 0; i < $(".js-ship-route-number").length; i++) {
    var item = $(".js-ship-route-number")[i];
    $(item).text(`مسیر ${i + 1}`);
  }
});

//economy click
$(document).delegate(".js-ship-economy-target>button", "click", function () {
  $(this).next(".js-ship-travelers").fadeToggle();
  $(this).next(".js-ship-travelers").toggleClass("show-mobile");
  if (documentWidth < 992) {
    $("html").addClass("no-scroll");
  }
});

//remove input text
$(document).delegate(".js-ship-close-tmenu", "click", function () {
  $(this).closest(".js-ship-travelers").hide();
  $("html").removeClass("no-scroll");
});

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

var cityList = [];

//autoComplete
function autoSearch($this) {
  if ($($this).closest(".js-ship-cities").length) {
    if ($(".js-booking-section.active").attr("data-searchType") === "internal-ship") {
      if (typeof shipInternalCityList != "undefined") {
        cityList = shipInternalCityList;
      }
    } else {
      if (typeof shipExternalCityList != "undefined") {
        cityList = shipExternalCityList;
      }
    }
  }

  $(".js-tab-nav .js-tab-nav-header button").on("click", function () {
    setTimeout(function () {
      if ($(".js-tab-nav").find("li.active").attr("data-searchType") === "internal-ship") {
        if (typeof shipInternalCityList != "undefined") {
          cityList = shipInternalCityList;
        }
      } else {
        if (typeof shipExternalCityList != "undefined") {
          cityList = shipExternalCityList;
        }
      }
    }, 0);
  });

  $.widget("custom.autocomplete", $.ui.autocomplete, {
    _renderMenu: function (ul, items) {
      var that = this,
        currentCategory = "";
      var sortedByFeatured = items.sort(sortArrayObject("isFeatured", "desc"));
      $.each(sortedByFeatured, function (index, item) {
        if (Object.keys(item).length) {
          that._renderItemData(ul, item);

          // if (!item.label) {
          //   $.each(item, function (index, item) {
          //     that._renderItemData(ul, item);
          //   })
          // }
        }
      });

      if (ul.find(".autocomplete-category-title").length === 1) {
        ul.find(".autocomplete-category-title").remove();
      }
    },

    _renderItem: function (ul, item) {
      var li = "";

      if (Object.keys(item).length) {
        var className = item.isRtl ? "rtl" : "ltr";
        ul.removeClass("rtl ltr");
        ul.addClass(className);

        if (!item.hasOwnProperty("airport") && item.label) {
          li +=
            '<li><span class="item-wrapper">' +
            '<i class="icon-map"></i><div><span class="city-title">' +
            item.label +
            "</span>";

          if (item.hasOwnProperty("airports") && item.airports !== null) {
            li += '<strong class="sub-title">همه بندرها</strong>';
          } else if (item.hasOwnProperty("airports") && item.airports === null) {
            li += '<strong class="sub-title"> (' + item.code.toUpperCase() + ")</strong>";
          }

          li += "</span></div></li>";
        } else if (item.hasOwnProperty("airport") && item.requestTerm != "" && item.airport) {
          var subdirectoryIcon = '<i class="icon-enter"></i>';
          li +=
            '<li class="airports"><div><span class="item-wrapper">' +
            subdirectoryIcon +
            '<span class="city-title"> <i class="icon-plane"></i>' +
            item.label +
            "</span>";
          li += "</span></div></li>";
        }
      }

      return $(li).appendTo(ul);
    },
  });

  $this
    .autocomplete({
      minLength: 0,
      delay: 400,
      appendTo: $this.next(),
      search: function (event) {
        $this.closest(".js-ship-city").find(".js-search-loading").show();
        if (
          $this.is(".js-ship-to-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") === "internal-ship"
        ) {
          cityList = typeof shipInternalCityList != "undefined" ? shipInternalCityList : [];
        }
        if (
          $this.is(".js-ship-to-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") === "external-ship"
        ) {
          cityList = typeof shipExternalCityList != "undefined" ? shipExternalCityList : [];
        }
        if (
          $this.is(".js-ship-from-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") === "internal-ship"
        ) {
          cityList = shipInternalCityList;
        }
        if (
          $this.is(".js-ship-from-city") &&
          $(".js-tab-nav").find("li.active").attr("data-searchType") === "external-ship"
        ) {
          cityList = shipExternalCityList;
        }

        $(this).closest(".js-ship-city").addClass("show-mobile");

        if (documentWidth < 992) {
          $("html").addClass("no-scroll");
        }
        $(this).parent().find(".error-message").remove();
      },
      source: function (request, response) {
        if ($this.val() && cityList != null) {
          var srcType = $this.closest(".js-ship-cities").attr("data-searchType");

          getUrl(srcType);
          $this.closest(".js-ship-city").find(".js-search-loading").show();
          $.ajax({
            url: sourceUrl,
            data: {
              keyword: request.term,
              orginPlace: $($this).is(".js-ship-from-city"),
            },

            dataType: "json",
            success: function (data) {
              $this.closest(".js-ship-city").find(".js-search-loading").hide();
              //ship
              if ($($this).closest(".js-ship-cities").length) {
                var shipsArr = [],
                  cities = {},
                  airports = {};
                response(
                  (shipsArr = []),
                  $.map(data.results, function (obj) {
                    cities = {
                      label: obj.label,
                      value: obj.cityTitle + "(" + obj.code + ")",
                      code: obj.code,
                      cityTitle: obj.cityTitle,
                      airports: obj.airports,
                      isRtl: data.isRtl,
                      isFeatured: obj.isFeatured,
                      requestTerm: request.term,
                    };
                    shipsArr.push(cities);

                    if (obj.airports != null && obj.airports.length) {
                      $.map(obj.airports, function (airport) {
                        airports = {
                          airport: true,
                          label: airport.label,
                          code: airport.code,
                          value: airport.label,
                          isRtl: data.isRtl,
                          isFeatured: obj.isFeatured,
                          cityTitle: airport.cityTitle,
                          requestTerm: request.term,
                        };
                        shipsArr.push(airports);
                      });
                    }

                    return [cities, shipsArr.filter((a) => a.airport === true)];
                  }),
                );
              }
            },
            error: function () {
              $this.closest(".js-ship-city").find(".js-search-loading").hide();
            },
          });
        } else {
          $this.closest(".js-ship-city").find(".js-search-loading").hide();
          if (cityList != null) {
            return response(cityList);
          } else {
            return [];
          }
        }
      },
      open: function () {
        var inputObj = $this;

        inputObj.next(".js-ship-search-list").children("ul").width(inputObj.closest(".js-ship-cities").width());
        inputObj
          .next(".js-ship-search-list")
          .children("ul")
          .offset({
            left: inputObj.closest(".js-ship-cities").offset().left,
          });
        inputObj.closest(".js-ship-cities").find(".js-ship-from-city").addClass("focusedInput");
        $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");

        //off autocomplete in chrome
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $this.attr("autocomplete", "off");
        }

        inputObj
          .next(".js-ship-search-list")
          .children("ul")
          .css({
            top: "+=" + 12,
          });
      },

      close: function () {
        $("html").removeClass("no-scroll");
      },

      select: function (e, ui) {
        $(this).attr("data-code", ui.item.code);
        $(this).attr("data-title", ui.item.cityTitle);
        $(this).attr("data-value", ui.item.value);
        $(this).val();

        $(this).data({
          code: ui.item.code,
          title: ui.item.cityTitle,
          value: ui.item.value,
        });

        $(this).attr("placeholder", ui.item.value);

        $this.parent().find(".error-message").remove();
        $this.removeClass("notValid");

        if ($(this).closest(".js-ship-serveral-routes-container").length && $(this).hasClass("js-ship-to-city")) {
          $(this).closest(".js-ship-routes-row").find(".js-ship-pick-date").trigger("focus");

          if ($(this).closest(".js-ship-routes-row").next().length) {
            if (!$(this).closest(".js-ship-routes-row").next().find(".js-ship-from-city").val()) {
              if ($(window).width() > 992) {
                $(this).attr("placeholder", ui.item.value);
              }

              $(this).parent().find(".error-message").remove();
            }
          }
        }

        if ($(window).width() <= 992) {
          $(".js-ship-city").removeClass("show-mobile");
          $(this)
            .closest(".js-ship-city")
            .find(".js-input-layout")
            .html("<span>" + ui.item.value + "</span>");
          $("html").removeClass("no-scroll");
          $this.autocomplete("close");
          $this.trigger("blur");
        }

        if ($(this).is(".js-ship-from-city")) {
          $(this).closest(".js-ship-cities").find(".js-ship-to-city").autocomplete("search");

          let timeOut = setTimeout(() => {
            $(this).closest(".js-ship-cities").find(".js-ship-to-city").trigger("focus");
            clearTimeout(timeOut);
          }, 0);
        } else if ($(this).is(".js-ship-to-city")) {
          $(this).closest(".js-ship-one-or-two-route-container").find(".js-ship-pick-date").datepicker("show");
          setTimeout(function () {
            document.activeElement.blur();
            // document.activeElement.focusout()
          }, 0);
        }

        $this.parent().find(".error-message").remove();
        $this.removeClass("notValid");
        $(this).parent().find(".error-message").remove();

        tagManager({ value: ui.item.value, type: searchType });
      },
    })
    .bind("focus", function (event) {
      if ($(window).width() > 992 || $(".js-ship-city").hasClass("show-mobile")) {
        $(this).val("");
        $(this).autocomplete("search");
        $this.closest(".js-ship-city").find(".js-search-loading").hide();
      }
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
      $this.closest(".js-ship-city").find(".js-search-loading").hide();
    });
}

//layout in mobile
$(".js-ship").delegate(".js-input-layout", "click", function () {
  $(this).closest(".js-ship-city").addClass("show-mobile");
  $(this).closest(".js-ship-city").find("input").trigger("focus");
  $(this).closest(".js-ship-city").find("input").trigger("search");
});

// init datePicker
function datePicker() {
  setTimeout(function () {
    $(".js-ship .js-ship-departure").pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      isDependenceDates: false,
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      customClass: "lightTheme",
      showAllMonthsinList: false,
      langType: datePickerMode === 1 ? '' : 'fa',
      blurInmobile: true,
      dayNamesShortFa: ["1شنبه", "2شنبه", "3شنبه", "4شنبه", "5شنبه", "جمعه", "شنبه"],
      dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
      enterDateTitle: "تاریخ رفت",
      exitDateTitle: "تاریخ برگشت",
      enterDateTitleEn: "Departure date",
      exitDateTitleEn: "Retun date",
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
    });
  }, 100);
}

function newdatePicker() {
  $(".js-ship-routes-row")
    .last()
    .find(".js-ship-departure")
    .pickDate({
      dateFormat: "yy/mm/dd",
      dateFormatEn: "yy M dd",
      changeMonthAllow: false,
      changeYearAllow: false,
      showButtonPanel: true,
      blurInmobile: true,
      isDependenceDates: false,
      customClass: "lightTheme",
      showCurrentAtPos: 0,
      numberOfMonths: $(window).width() > 991 ? 2 : 1,
      minDate: -0,
      maxDate: "+1Y",
      showAllMonthsinList: false,
      langType: datePickerMode === 1 ? '' : 'fa',
      fillHidden: {
        enable: true,
        outPut: "en", //en | Dependent_On_SelectedDate | fa
        customformatInhidden: "YYYY-MM-DD",
      },
    });
}

// get url for ajax
function getUrl(srcType) {
  if (srcType === "internal-ship") {
    sourceUrl = "/airport/iranianairports/";
  } else if (srcType === "external-ship") {
    sourceUrl = "/airport/airports/";
  }
}
